import { authHeader } from '../../_helpers';
import axios from 'axios';

export const csvDownloadService = {
    csvDownloadHandler,
};
axios.defaults.headers.common = authHeader();

function csvDownloadHandler(data) {
    return axios.post(`/masters/csv-download`,data)
        .then(response => {
            return response;
        });
}






// WEBPACK FOOTER //
// ./src/_services/csvDownload/csvDownload.service.js